module.exports = __webpack_public_path__ + "img/squiggle-snake.81f611ac.svg";